





























































































import Vue from 'vue'

export default Vue.extend({
	head(this: any) {
		return {
			title: `${this.$t('titles.privacy')} | WithIn`,
		}
	},
})
